import WistiaVideo from './WistiaVideo';

export default WistiaVideo;
